export const isNavigatorConnectionSupported = (
    navigator: Navigator
): navigator is Navigator & {
    connection: {
        saveData: boolean;
    };
} => {
    return (
        "connection" in navigator &&
        typeof navigator.connection === "object" &&
        "saveData" in navigator.connection! &&
        typeof navigator.connection.saveData !== "undefined"
    );
};
